<lib-edge-router-form>
  @if (showEntityTabs) {
    <div class="tabs-region" slot="tabs-slot" [class.overlay-active]="activeTab !== 'overview'">
      <div class="tab-nav" role="tablist">
        <a role="tab" class="tab" [routerLink]="['/routers', entityId, 'overview']" [replaceUrl]="true" routerLinkActive="active">Overview</a>
        <a role="tab" class="tab" [routerLink]="['/routers', entityId, 'events']" [replaceUrl]="true" routerLinkActive="active">Events</a>
        <a role="tab" class="tab" [routerLink]="['/routers', entityId, 'metrics']" [replaceUrl]="true" routerLinkActive="active">Metrics</a>
      </div>
      @if (activeTab === 'events') {
        <div class="entity-tab-panel">
          <app-events-tab [data]="entityTabData"></app-events-tab>
        </div>
      }
      @if (activeTab === 'metrics') {
        <div class="entity-tab-panel">
          <app-metrics-tab [data]="entityTabData"></app-metrics-tab>
        </div>
      }
    </div>
  }
  @if (showProvider) {
    <div
      class="nf-hosted-config-container"
      slot="column-1-slot-1"
      [ngClass]="{ 'focus-hosting': focusNfHosting, disabled: disableHostPod }"
      matTooltip="{{ hostAreaToolTip }}"
      matTooltipPosition="below"
      matTooltipShowDelay="300"
      >
      @if (!showLoader) {
        <div class="nf-hosted-title-container">
          <div class="nf-hosted-title">
            <div class="netfoundryHostedIcon"></div>
            <span class="form-field-title">HOSTED BY NETFOUNDRY</span>
            <div
              class="form-field-info infoicon"
              matTooltip="Configure this router to be hosted by NetFoundry in a data center"
              matTooltipPosition="below"
              matTooltipShowDelay="300"
            ></div>
            @if (svc.inProcess) {
              <span class="spinner" (click)="goToProcesses()"></span>
            }
          </div>
          @if (!useStrictReadonlyForm) {
            <div
              class="save-button"
              [ngClass]="{ disabled: disableHostButton }"
              (click)="editHosting()"
              matTooltip="{{ hostButtonToolTip }}"
              matTooltipPosition="below"
              matTooltipShowDelay="300"
              >
            {{ showUpdating ? 'Updating' : (svc?.nfRouterData?.id ? 'Edit' : 'Setup') + ' Hosting' }}
            </div>
          }
        </div>
      }
      @if (showHostingConfig && !showLoader) {
        <netfoundry-ui-router-hosting-config
          [readonly]="true"
        ></netfoundry-ui-router-hosting-config>
      }
      @if (showLoader) {
        <div class="loader-container">
          <span class="spinner"></span>
        </div>
      }
    </div>
  }
  @if (svc.zitiRouterData.id) {
    <div
      class="edge-router-registration-container"
      slot="column-2-slot-1"
      >
      @if (hasEnrollmentJwt && !enrollmentExpired && !useStrictReadonlyForm) {
        <lib-form-field-container [showHeader]="false">
          <div class="share-identity-container">
            <span class="info-text">SHARE THIS EDGE ROUTER</span>
            <div class="download-button share-button" (click)="svc.shareRegistration(svc.zitiRouterData)">
              <div class="icon-email"></div>
              <div>SEND REGISTRATION EMAIL</div>
              <div class="icon-Icon_Share"></div>
            </div>
          </div>
        </lib-form-field-container>
      }
      <div class="nf-registration-container">
        <netfoundry-ui-edge-router-links>
        </netfoundry-ui-edge-router-links>
      </div>
    </div>
  }

</lib-edge-router-form>
